// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__qR4EQ","list":"PatternAutocomplete_list__3zfk-"};